module.exports = "/_next/static/images/mrfattypantsbignormal-98c0516b15dd618b37858fd3156555cd.png";